module.exports = Jsw.skinUrl + "/images/sticker-collection/burst/heart_02.png?9eeccef1ee71dcbdb8b9455f100b5dfb";